import React from "react";
import { Eye, Video } from "lucide-react";

const DirectorRecentAuditionsTable = ({
  activeTab,
  setActiveTab,
  filteredApplications,
  navigate
}) => {
  const getStatusBadge = (status = '') => {
    const s = String(status || '').toLowerCase();
    if (s === "pending" || s === "applied") return <span className="dd-badge badge-yellow">PENDING</span>;
    if (s === "resubmit") return <span className="dd-badge" style={{ background: "rgba(168, 85, 247, 0.15)", color: "#c084fc" }}>RESUBMIT</span>;
    if (s === "reviewed") return <span className="dd-badge badge-blue">REVIEWED</span>;
    if (s === "shortlisted" || s === "selected") return <span className="dd-badge badge-green">SHORTLISTED</span>;
    if (s === "rejected") return <span className="dd-badge badge-red">REJECTED</span>;
    return <span className="dd-badge badge-gray">{String(status || 'PENDING').toUpperCase()}</span>;
  };

  const getTypeBadge = (type = '') => {
    const t = String(type || '').toUpperCase();
    if (t.includes("ONLINE")) return <span className="dd-type-badge type-online"><Video size={12}/> ONLINE</span>;
    if (t.includes("SLOT_BOOKING") || t.includes("WALK")) return <span className="dd-type-badge type-walkin">WALK IN</span>;
    return <span className="dd-type-badge type-gray">{t || 'ONLINE'}</span>;
  };

  return (
    <div className="dd-card dd-table-card">
      <div className="dd-card-header d-flex justify-content-between align-items-center">
        <h2>Recent Auditions</h2>
        
        {/* Desktop Filter Buttons */}
        <div className="dd-table-filters d-none d-md-flex">
          <button className={activeTab === "all" ? "active" : ""} onClick={() => setActiveTab("all")}>All</button>
          <button className={activeTab === "pending" ? "active" : ""} onClick={() => setActiveTab("pending")}>Pending</button>
          <button className={activeTab === "shortlisted" ? "active" : ""} onClick={() => setActiveTab("shortlisted")}>Shortlisted</button>
        </div>

        {/* Mobile Select Dropdown (Right End) */}
        <select 
          className="dd-select d-md-none" 
          value={activeTab} 
          onChange={(e) => setActiveTab(e.target.value)}
        >
          <option value="all">All</option>
          <option value="pending">Pending</option>
          <option value="shortlisted">Shortlisted</option>
        </select>
      </div>

      <div className="dd-table-responsive">
        <table className="dd-table">
          <thead>
            <tr>
              <th>DATE</th>
              <th>CANDIDATE NAME</th>
              <th>ROLE TITLE</th>
              <th>PROJECT</th>
              <th>TYPE</th>
              <th>STATUS</th>
              <th>ACTION</th>
            </tr>
          </thead>
          <tbody>
            {filteredApplications.map((row) => (
              <tr key={row.id || row.roleApplicationId}>
                <td className="dd-text-muted">{row.date}</td>
                <td>
                  <div className="dd-candidate-cell">
                    <div className="dd-avatar">{row.candidate ? String(row.candidate).charAt(0) : 'U'}</div>
                    <span className="dd-candidate-name">{row.candidate}</span>
                  </div>
                </td>
                <td className="dd-font-medium">{row.role}</td>
                <td className="dd-text-muted">{row.project}</td>
                <td>{getTypeBadge(row.type)}</td>
                <td>{getStatusBadge(row.status)}</td>
                <td>
                  <button
                    className="btn d-flex align-items-center justify-content-center"
                    style={{ 
                      width: '36px', 
                      height: '36px', 
                      borderRadius: '6px', 
                      padding: '0', 
                      backgroundColor: '#2563eb', 
                      border: 'none',
                      cursor: 'pointer',
                      transition: 'all 0.2s ease-in-out'
                    }}
                    title="View Application"
                    onClick={() =>
                      navigate(`/dashboard/manage-applications/${row.id || row.roleApplicationId}`)
                    }
                  >
                    <Eye size={18} color="#ffffff" />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DirectorRecentAuditionsTable;
